module.exports = __webpack_public_path__ + "static/img/sukk_r.abd8ec0a.webp";